import { styled } from '@mui/material/styles';
import { Box } from 'src/components/Box';

interface StickyProps {
  backgroundColor?: string;
  location?: 'top' | 'bottom';
}

export const Sticky = styled(Box)<StickyProps>(
  ({ theme, backgroundColor, location = 'top' }) => ({
    position: 'sticky',
    ...(location === 'top' ? { top: 0 } : { bottom: 0 }),
    zIndex: theme.zIndex.appBar, // Ensure it's above other content; use a custom zIndex if needed
    backgroundColor: backgroundColor || 'background.paper', // use theme default or provided
  })
);
